const cardOpenStatusDirective = {
  getOpenCardStatus() {

    let cardStatus = JSON.parse(sessionStorage.getItem('IOT_StoredCards'));
    //if (!cardStatus)
    return cardStatus;
  },

  setDataVolumeChartStatus() {
    let cardStatus = this.getOpenCardStatus();
    cardStatus['dataVolume-chart-collapse'] = !cardStatus['dataVolume-chart-collapse'];
    sessionStorage.setItem('IOT_StoredCards', JSON.stringify(cardStatus));
    return true;
  },

  setTopMetricsStatus() {
    let cardStatus = this.getOpenCardStatus();
    cardStatus['topMetrics-collapse'] = !cardStatus['topMetrics-collapse'];
    sessionStorage.setItem('IOT_StoredCards', JSON.stringify(cardStatus));
    return true;
  },

  setDataVolumeMapStatus() {
    let cardStatus = this.getOpenCardStatus();
    cardStatus['dataVolume-map-collapse'] = !cardStatus['dataVolume-map-collapse'];
    sessionStorage.setItem('IOT_StoredCards', JSON.stringify(cardStatus));
    return true;
  },

  simInventoryStatus() {
    let cardStatus = this.getOpenCardStatus();
    cardStatus['sim-inventory-collapse'] = !cardStatus['sim-inventory-collapse'];
    sessionStorage.setItem('IOT_StoredCards', JSON.stringify(cardStatus));
    return true;
  },

  setWatchdogAlertStatus() {
    let cardStatus = this.getOpenCardStatus();
    cardStatus['watchdog-alerts-collapse'] = !cardStatus['watchdog-alerts-collapse'];
    sessionStorage.setItem('IOT_StoredCards', JSON.stringify(cardStatus));
    return true
  }
};

export default cardOpenStatusDirective


